import { OrderService } from "entities/OrderService";
import {
	OrderStatus,
	OrderStatusAllowedFromDraft,
	OrderStatusCustomerEdit,
} from "entities/OrderStatus";
import { OSFCUserRoles, UserRole } from "entities/UserRole";
import React from "react";
import { SelectInput } from "react-admin";
import { isInArray } from "utils/general";

import { SelectDisabledInput } from "./SelectUppercaseInput";

const isCarInTerminal = (order) => {
	if (order.service === OrderService.reloadCarCar) {
		return order.is_eta_arrived && order.is_etd_arrived;
	} else if (
		isInArray(
			[OrderService.reloadCarTerminalCar, OrderService.crossDock, OrderService.per],
			order.service
		)
	) {
		return order.is_eta_arrived || (order.is_eta_arrived && order.is_etd_arrived);
	} else if (order.service === OrderService.intoPlukkStorage) {
		return (order.eta_date && order.is_eta_arrived) || (order.etd_date && order.is_etd_arrived);
	}

	return false;
};

export const getStatusAllowedIds = (rec, permissions) => {
	let statusAllowedIds = Object.values(OrderStatus);

	if (rec) {
		const canEditCompletedOrder = permissions.role === UserRole.admin || permissions.can_edit_completed_order;
		if (rec.status === OrderStatus.ORDER_COMPLETED && !canEditCompletedOrder) {
			statusAllowedIds = [];
		} else if (rec.rank && rec.rank_auto && isCarInTerminal(rec)) {
			if (rec.rank_auto === 6 && rec.status === OrderStatus.LOADING_STARTED) {
				statusAllowedIds = [OrderStatus.DEVIATION];
				if (
					isInArray(
						[OrderService.reloadCarTerminalCar, OrderService.crossDock, OrderService.per],
						rec.service
					) &&
					!rec.is_etd_arrived
				) {
					statusAllowedIds.push(OrderStatus.LOAD_IN_TERMINAL_STORAGE);
				} else {
					statusAllowedIds.push(OrderStatus.LOADING_COMPLETED);
				}
			} else if (rec.rank_auto === 5 && rec.status === OrderStatus.DEVIATION) {
				statusAllowedIds = [OrderStatus.LOADING_STARTED];
				if (
					isInArray(
						[OrderService.reloadCarTerminalCar, OrderService.crossDock, OrderService.per],
						rec.service
					) &&
					!rec.is_etd_arrived
				) {
					statusAllowedIds.push(OrderStatus.LOAD_IN_TERMINAL_STORAGE);
				} else {
					statusAllowedIds.push(OrderStatus.LOADING_COMPLETED);
				}
			}
		}
		if (rec.status === OrderStatus.DRAFT) {
			return OrderStatusAllowedFromDraft;
		}
	}

	statusAllowedIds = statusAllowedIds.filter((s) => s !== OrderStatus.DRAFT);

	return statusAllowedIds;
};

export const OrderStatusEditField = ({ data, permissions, ...rest }) => {
	const isOSFCUser = permissions && OSFCUserRoles.has(permissions.role);

	let statusAllowedIds = [];

	if (isOSFCUser) {
		statusAllowedIds = getStatusAllowedIds(data, permissions);
	} else if (data.status === OrderStatus.DRAFT) {
		statusAllowedIds = OrderStatusAllowedFromDraft;
	} else {
		statusAllowedIds = OrderStatusCustomerEdit.filter((s) => s !== OrderStatus.DRAFT);
	}

	if (!statusAllowedIds) return <SelectInput optionText="name" {...rest} />;

	return <SelectDisabledInput allowedIds={statusAllowedIds} optionText="name" {...rest} />;
};
